import { render, staticRenderFns } from "./TabEntidadFederativa.vue?vue&type=template&id=124ed832"
import script from "./TabEntidadFederativa.vue?vue&type=script&lang=js"
export * from "./TabEntidadFederativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124ed832')) {
      api.createRecord('124ed832', component.options)
    } else {
      api.reload('124ed832', component.options)
    }
    module.hot.accept("./TabEntidadFederativa.vue?vue&type=template&id=124ed832", function () {
      api.rerender('124ed832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/formalizacionactas/TabEntidadFederativa.vue"
export default component.exports